import React, { useState } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import Sidebar from './Sidebar';
import AgentMarketplace from './AgentMarketplace';
import AgentFlowEditor from './AgentFlowEditor';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HelpIcon from '@mui/icons-material/Help';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { clearStoredAuthTokens } from '../utils/auth';
import { dsVar } from '../theme/tokens';

const AdminLanding = ({ isEditor = false }) => {
    const navigate = useNavigate();
    const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);

    const handleUserMenuOpen = (event) => {
        setUserMenuAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setUserMenuAnchorEl(null);
    };

    const handleSignOut = () => {
        clearStoredAuthTokens();
        handleUserMenuClose();
        navigate('/login');
    };

    return (
        <div className="flex h-screen overflow-hidden bg-page font-sans text-fg selection:bg-accent selection:text-on-accent">
            <Sidebar activePage="ai-studio" />

            {/* Main Content */}
            <main className="flex-1 flex flex-col overflow-hidden bg-page">
                {!isEditor && (
                    <header className="h-16 border-b border-line/50 bg-page/80 backdrop-blur-md px-8 flex items-center justify-between sticky top-0 z-10 m-0">
                        <div className="flex-1 max-w-2xl text-left">
                            <div className="relative group flex items-center justify-start h-full">
                                <SearchIcon className="absolute left-3 text-fg-muted group-focus-within:text-accent-fg transition-colors" />
                                <input
                                    className="w-full bg-surface border-none rounded-lg py-2 pl-10 pr-4 text-sm focus:ring-1 focus:ring-accent-fg placeholder:text-fg-muted text-fg outline-none"
                                    placeholder="Search flow templates..."
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-4 ml-8">
                            <button className="p-2 text-fg-2 hover:text-accent-fg transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center">
                                <NotificationsIcon />
                            </button>
                            <button className="p-2 text-fg-2 hover:text-accent-fg transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center">
                                <HelpIcon />
                            </button>
                            <button
                                className="p-2 text-fg-2 hover:text-accent-fg transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center"
                                onClick={handleUserMenuOpen}
                                aria-label="Open user menu"
                            >
                                <AccountCircleIcon />
                            </button>
                            <Menu
                                anchorEl={userMenuAnchorEl}
                                open={Boolean(userMenuAnchorEl)}
                                onClose={handleUserMenuClose}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                PaperProps={{
                                    sx: {
                                        borderRadius: '12px',
                                        backgroundColor: dsVar('surface'),
                                        color: dsVar('fg-body'),
                                        border: `1px solid ${dsVar('line')}`,
                                        minWidth: '180px',
                                        mt: 1
                                    }
                                }}
                            >
                                <MenuItem
                                    disabled
                                    sx={{
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: dsVar('fg-2'),
                                        borderBottom: `1px solid ${dsVar('line')}`,
                                        opacity: '1 !important'
                                    }}
                                >
                                    {localStorage.getItem('org_id') || 'User'}
                                </MenuItem>
                                <MenuItem
                                    onClick={handleSignOut}
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        fontSize: '0.9rem',
                                        color: dsVar('accent-fg'),
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 222, 89, 0.08)'
                                        }
                                    }}
                                >
                                    <LogoutIcon fontSize="small" />
                                    Sign out
                                </MenuItem>
                            </Menu>
                        </div>
                    </header>
                )}

                <div className={`flex-1 overflow-y-auto ${isEditor ? '' : 'p-8'}`}>
                    {isEditor ? <AgentFlowEditor /> : <AgentMarketplace />}
                </div>
            </main>
        </div>
    );
};

export default AdminLanding;
